import { gql } from '@apollo/client';

export const GetCurrentUserQuery = gql`
    query GetCurrentUser {
        getCurrentUser {
            id
            username
            fullName
            tfaEnabled
            email
            roles
            createdAt
            updatedAt
            student {
                id
                fullName
            }
            school {
                id
                shortName
                currentStudentsCount
                maxStudentsCount
                studentsAddMode
                canDeleteStudent
                region {
                    id
                    name
                }
                location {
                    id
                    name
                }
            }
            grants {
                category
                actions
            }
        }
    }
`;
